import {Component} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Card} from 'primeng/card';
import {ProjectBaseStepComponent} from '../../../project-base-step/project-base-step.component';
import {TenderPhaseType} from '@frontend/shared-api';
import {ProviderResultsTableComponent} from '../../../../../../shared/components/table/provider-results-table/provider-results-table.component';

@Component({
  selector: 'app-step-7-4-provider-results',
  imports: [TranslocoPipe, Card, ProviderResultsTableComponent],
  templateUrl: './step-5-4-provider-results.component.html',
})
export class Step54ProviderResultsComponent extends ProjectBaseStepComponent {
  protected readonly TenderPhaseType = TenderPhaseType;

  constructor() {
    super();
  }
}
